import type { HTMLAttributes } from 'react'
import { twMerge } from 'tailwind-merge'

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  quantity?: number
}

export function Skeleton({ className, quantity, ...rest }: SkeletonProps) {
  if (quantity) {
    return Array.from({ length: quantity }).map((_, index) => (
      <div
        key={index}
        className={twMerge('animate-pulse rounded-lg bg-zinc-300', className)}
        {...rest}
      />
    ))
  }

  return (
    <div
      className={twMerge('animate-pulse rounded-lg bg-zinc-300', className)}
      {...rest}
    />
  )
}
